import React from 'react';
import { useIntl } from 'react-intl';
import { DictionaryEvidence, EmptyComponent, Evidence } from '@eas/common-web';
import { VoltageLevel } from '@models';
import { EvidenceApiUrl } from '@enums';
import { useColumns } from './voltage-level-columns';
import { Fields } from './voltage-level-fields';

export function VoltageLevels() {
  const intl = useIntl();
  const columns = useColumns();

  const evidence = DictionaryEvidence.useDictionaryEvidence<VoltageLevel>({
    identifier: 'VOLTAGE_LEVEL',
    apiProps: {
      url: EvidenceApiUrl.VOLTAGE_LEVELS,
    },
    tableProps: {
      columns,
      tableName: intl.formatMessage({
        id: 'ZSD__VOLTAGE_LEVEL__TABLE__TITLE',
        defaultMessage: 'Úrovne napätia',
      }),
      showBulkActionButton: false,
      showReportButton: false,
      defaultSorts: [],
    },
    detailProps: {
      toolbarProps: {
        title: intl.formatMessage({
          id: 'ZSD__VOLTAGE_LEVEL__DETAIL__TITLE',
          defaultMessage: 'Úroveň napätia',
        }),
        subtitle: (type) => type?.name ?? '',
        showBtn: () => false,
      },
      GeneralFieldsComponent: EmptyComponent,
      FieldsComponent: Fields,
    },
  });

  return <Evidence {...evidence} />;
}
